import Footer from '../components/Footer';
import Navigation from '../components/Navigation';

const TermsAndConditionsPage = () => {
    return (
        <div className="wp-singular page-template page-template-elementor_header_footer page page-id-3249 wp-custom-logo wp-embed-responsive wp-theme-hello-elementor theme-default elementor-default elementor-template-full-width elementor-kit-3179 elementor-page elementor-page-3249">
            <Navigation />
            <div data-elementor-type="wp-page" data-elementor-id="3247" className="elementor elementor-3247"
                data-elementor-post-type="page">
                <div className="elementor-element elementor-element-04de9f9 e-flex e-con-boxed e-con e-parent" data-id="04de9f9"
                    data-element_type="container">
                    <div className="e-con-inner">
                        <div className="elementor-element elementor-element-9387d07 e-con-full e-flex e-con e-child"
                            data-id="9387d07" data-element_type="container"
                            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                            <div className="elementor-element elementor-element-228764e elementor-widget elementor-widget-heading"
                                data-id="228764e" data-element_type="widget" data-widget_type="heading.default">
                                <div className="elementor-widget-container">
                                    <h1 className="elementor-heading-title elementor-size-default">Termos e Condições</h1>
                                </div>
                            </div>
                        </div>
                        <div className="elementor-element elementor-element-51ec7b7 elementor-widget elementor-widget-text-editor"
                            data-id="51ec7b7" data-element_type="widget" data-widget_type="text-editor.default">
                            <div className="elementor-widget-container">
                                <h2>1. Aceitação dos Termos</h2>
                                <p>Ao aceder e utilizar o site Casinoplusportugal (disponível em Casinoplusportugal.site), o utilizador
                                    concorda com os presentes Termos e Condições. Caso não concorde com alguma parte destes
                                    termos, deve abster-se de utilizar o site.</p>
                                <h2>2. Natureza do Serviço</h2>
                                <p>Casinoplusportugal é uma plataforma de comparação e informação sobre casinos online legais e
                                    licenciados em Portugal.<br />Não operamos casinos, não aceitamos apostas nem processamos
                                    pagamentos.</p>
                                <p>O nosso objetivo é fornecer conteúdo informativo e atualizado com base em fontes públicas e
                                    dados de operadoras licenciadas pelo SRIJ (Serviço de Regulação e Inspeção de Jogos).</p>
                                <h2>3. Acesso ao Site</h2>
                                <p>O uso deste site está restrito a maiores de 18 anos. Ao utilizar o site, declara que tem
                                    idade legal para aceder a conteúdos relacionados com jogos de fortuna ou azar em Portugal.
                                </p>
                                <h2>4. Conteúdos e Responsabilidade</h2>
                                <p>Todo o conteúdo apresentado (textos, imagens, comparações, classificações) é produzido com
                                    base em pesquisa independente. Apesar do nosso esforço por manter a informação atualizada,
                                    não garantimos a total precisão ou atualidade de todos os dados.</p>
                                <p>O utilizador é responsável por verificar diretamente com os sites dos operadores as condições
                                    dos bónus, jogos e políticas aplicáveis.</p>
                                <h2>5. Ligações Externas</h2>
                                <p>O site Casinoplusportugal contém links para sites de terceiros (ex. casinos licenciados). Não nos
                                    responsabilizamos pelo conteúdo, segurança ou políticas de privacidade desses sites.
                                    Recomendamos que leia os termos e políticas dos sites externos antes de realizar qualquer
                                    ação.</p>
                                <h2>6. Propriedade Intelectual</h2>
                                <p>Todos os textos, gráficos, logótipos e conteúdos do site são propriedade de Casinoplusportugal,
                                    salvo indicação em contrário. É proibida a reprodução, distribuição ou modificação sem
                                    autorização prévia por escrito.</p>
                                <h2>7. Alterações aos Termos</h2>
                                <p>Reservamo-nos o direito de alterar estes Termos e Condições a qualquer momento. Quaisquer
                                    alterações entrarão em vigor assim que forem publicadas nesta página. Recomendamos que
                                    consulte esta página regularmente.</p>
                                <h2>8. Contacto</h2>
                                <p>Para qualquer questão relacionada com estes Termos, contacte-nos através de:<br />📧 contacto@Casinoplusportugal.site
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default TermsAndConditionsPage